import { Link } from "@sprout/typography";
import useTranslation from "@hooks/use_translation";

const LegalLinks = () => {
  const { t } = useTranslation("misc");
  return (
    <div className="text-center">
      <p className="pb-4">
        <Link href="/users/agreement" external>
          {t("userAgreement")}
        </Link>
      </p>
      <p className="pb-4">
        <Link href="https://www.greenhouse.com/privacy-policy" external>
          {t("privacyPolicy")}
        </Link>
      </p>
      <p>
        <Link href="/do_not_share">{t("doNotShare")}</Link>
      </p>
    </div>
  );
};

export default LegalLinks;
